import React from "react";
import { motion } from "framer-motion";
import { Camera, Brain, TrafficCone, Target } from "lucide-react";

const STEPS = [
    {
        n: "01",
        icon: Camera,
        title: "Escaneie",
        desc: "Aponte a câmera para o código de barras ou para a embalagem do produto.",
    },
    {
        n: "02",
        icon: Brain,
        title: "Analise",
        desc: "O Dentro interpreta ingredientes, nutrientes e pontos de atenção.",
    },
    {
        n: "03",
        icon: TrafficCone,
        title: "Veja o veredito",
        desc: "Receba uma resposta clara por cores: verde, amarelo ou vermelho.",
    },
    {
        n: "04",
        icon: Target,
        title: "Personalize",
        desc: "O resultado considera suas restrições, alergias e objetivos.",
    },
];

export default function ComoFunciona() {
    return (
        <section
            id="como-funciona"
            data-testid="como-funciona-section"
            className="relative py-20 md:py-28 bg-[#F8FAFC]"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                    className="max-w-3xl"
                >
                    <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#16A34A]">
                        Como funciona
                    </span>
                    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1C3A] tracking-tight">
                        Escaneie. Entenda. Escolha melhor.
                    </h2>
                    <p className="mt-5 text-lg text-[#475569] leading-relaxed">
                        Em quatro passos simples, você transforma qualquer ida
                        ao supermercado em uma decisão consciente.
                    </p>
                </motion.div>

                <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {STEPS.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <motion.div
                                key={s.title}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.55, delay: i * 0.06 }}
                                data-testid={`step-card-${i + 1}`}
                                className="group relative bg-white rounded-3xl p-7 border border-slate-100 shadow-[0_8px_30px_rgba(11,28,58,0.04)] hover:shadow-[0_18px_50px_rgba(11,28,58,0.09)] hover:-translate-y-1 transition-all"
                            >
                                <div className="flex items-start justify-between">
                                    <div className="h-12 w-12 rounded-2xl bg-[#16A34A]/10 grid place-items-center text-[#16A34A]">
                                        <Icon size={22} strokeWidth={2.25} />
                                    </div>
                                    <span className="font-display text-4xl font-black text-[#0B1C3A]/10 leading-none">
                                        {s.n}
                                    </span>
                                </div>
                                <h3 className="mt-6 font-display text-xl font-extrabold text-[#0B1C3A]">
                                    {s.title}
                                </h3>
                                <p className="mt-2 text-[15px] text-[#475569] leading-relaxed">
                                    {s.desc}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
